import axios from 'axios';
import { APIResponse, QueuePlace } from './PublicClasses';

const ROOT_URL = process.env.REACT_APP_API_URL;
export const IS_DEBUG = process.env.REACT_APP_DEBUG=='1';
export const CDN_URL = process.env.REACT_APP_CDN_URL;
export const CAPTCHA_ACTIVE = process.env.REACT_APP_CAPTCHA_ACTIVE=='1';
export const CAPTCHA_KEY = process.env.REACT_APP_CAPTCHA_KEY;
export const FINGERPRINT_KEY = process.env.REACT_APP_FINGERPRINT_KEY;

interface PostOptions{
	token?: string,
}
async function post<T=any>(endpoint: string, data?: any, opts?: PostOptions) : Promise<APIResponse<T>>{
	var options : any = {
		headers: {
			'Content-Type': 'application/json',
		}
	}
	if(data instanceof FormData){
		options.headers['Content-Type'] = 'multipart/form-data';
	}
	if(opts?.token){
		options.headers["token"] = opts.token;
	}

	try{
		var ENDPOINT = `${ROOT_URL}/${endpoint}`;
		if(IS_DEBUG) console.log("POST "+ENDPOINT, options);
		var res = await axios.post(ENDPOINT, (data || {}), options);
		if(IS_DEBUG) console.log(` => Response: ${(res.headers['content-length']/1024).toFixed(2)} KB`);
		return res.data as APIResponse<T>;
	}catch(err){
		if(IS_DEBUG) console.error(err);
		return {
			error: true, 
			message: 'Hubo un error inesperado (APIP-LCL-1)',
			code: 'APIP-LCL-1',
		}
	}
};

var CACHE : { [x: string]: APIResponse<any> } = {};
var cachePost = async <T=any>(endpoint: string, key: string, data?: any) : Promise<APIResponse<T>>=>{
	if(CACHE[key]) return CACHE[key] as APIResponse<T>;
	var res = await post(endpoint, data);
	if(!res.error) CACHE[key] = res;
	return res;
}

async function joinQueue(website_id: number, token: string, unique_id: string, captcha: string, rejoin: boolean=false){
	return post<{
		ended: boolean,
		ended_message: string,
		wait_token: string,
		date_start: number,
		finish_token: string,
	}>('q/join', {
		website_id, 
		token: rejoin ? null : token,
		rejoin_token: rejoin ? token : null,
		unique_id,
		captcha,
	});
}

async function getPlace(token: string){
	return post<QueuePlace>('q/status', {}, { token });
}

async function sendProcessing(token: string){
	return post<{
		redirect_url: string
	}>('q/process', null, { token });
}

export default {
	getPlace,
	joinQueue,
	sendProcessing,
}